/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Description_Export_Status_Vo_Failed_AtInputs */



/**
* | output |
* | --- |
* | "Failed to export audio VO at event index {index}" |
*
* @param {Audio_Description_Export_Status_Vo_Failed_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_failed_at = /** @type {((inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_Failed_AtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'export de la VO à l'index d'événement ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Audio-Sprachausgabe beim Ereignisindex ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile esportare l'audio VO all'indice evento ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось экспортировать аудиозапись события с индексом ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo exportar el audio VO en el índice de evento ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出事件索引为 ${i?.index} 的音频 VO 失败`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント インデックス ${i?.index} のオーディオ VO をエクスポートできませんでした`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट इंडेक्स ${i?.index} पर ऑडियो VO निर्यात करने में विफलता`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao exportar o áudio VO no índice de evento ${i?.index}`)
	return /** @type {LocalizedString} */ (`Failed to export audio VO at event index ${i?.index}`)
});